
import { Vue } from "vue-class-component";

export default class Server extends Vue {}
